import { getOlderList, getOlderDetail, olderContact, addContact, editContact, getApproveList, searchSameAccount, getSameHouseOldersApi } from "@/services/all-api.js"
import axios from "axios"
function listTrans(obj) {
  const result = {
    data: obj.data.map((item, i) => ({
      gid: item.gid,
      num: obj.index * obj.size + i + 1,
      olderName: item.name,
      age: item.age,
      type: item.type == "0" ? "D类老人" : item.type == "1" ? "A类老人" : item.type == 2 ? "B类老人" : "C类老人",
      idCard: item.idCard,
      gender: item.gender == 0 ? "女" : "男",
      pensionMode: item.pensionMode == "0" ? "居家养老" : item.pensionMode == "1" ? "机构养老" : "社区养老",
      phone: item.phone,
      hasFaceInfo: item.hasFaceInfo,
      isBaseInfoPerfect: item.isBaseInfoPerfect,
      community: item.community || "-",
      status: item.status,
      pushToTalk: item.pushToTalk,
      pushToTalkType: item.pushToTalkType,
      telephone: item.telephone
    })),
    total: obj.total,
    index: obj.index,
    size: obj.size
  }
  return result
}
//老人基础信息详情转换
//老人养老服务详情信息转换
function detailTrans(item) {
  const result = {
    nurseWay: item.pensionmode,
    community: item.community,
    type: item.type == "1" ? "A类老人" : item.type == "2" ? "B类老人" : item.type == "3" ? "C类老人" : "D类老人",
    openTime: item.openAgedServiceTime,
    hasFaceInfo: item.hasFaceInfo,
    hasSameHouseHold: item.hasSameHouseHold,
    isBaseInfoPerfect: item.isBaseInfoPerfect,
    isOpenAgedService: item.isOpenAgedService
  }
  return result
}
//老人同户老人是否  以及 姓名基础信息
function sameAccount(item) {
  let obj;
  if (item.code === 1) {
    obj = {
      hasSameAccount: false,
      data: {}
    }

  } else if (item.code === 0) {
    obj = {
      hasSameAccount: true,
      data: {
        gid: item.data.gid,
        name: item.data.name,
        status: item.data.status,
        type: item.data.type == '0' ? "D类老人" : item.data.type == '1' ? 'A类老人' : item.data.type == '2' ? 'B类老人' : 'C类老人'
      }
    }
  }
  return obj
}

export default class dataApi {

  static firstGet(obj) {
    const allObj = {
      index: 0,
      size: 20,
      status: 0
    }
    const logOutObj = {
      index: 0,
      size: 20,
      status: 2
    }
    const updateObj = {
      index: 0, size: 20, status: 0, onlyUpdate: true
    }
    function getOriginOlder() {
      return getOlderList(allObj)
    }
    function getLogOutOlder() {
      return getOlderList(logOutObj)
    }
    function getUpdateOlder() {
      return getOlderList(updateObj)
    }
    return axios.all([getOriginOlder(), getLogOutOlder(), getUpdateOlder()]).then(
      axios.spread((all, logout, update) => {
        const obj = {
          allData: listTrans(all.data),
          logoutData: listTrans(logout.data),
          updateData: listTrans(update.data)
        }
        return obj
      })
    ).catch((err) => {
      return Promise.reject(`获取老人数据失败${err}`)
    })
  }
  static pageSearchGetFunc(obj) {
    async function tempFunc() {
      try {
        let result = await getOlderList(obj)
        return { data: listTrans(result.data) }
      }
      catch (e) {
        console.log(e)
      }
    }
    return tempFunc()
  }
  static getBase(obj) {
    return getOlderDetail(obj).then(
      (res) => {
        return res.data
      }
    )
  }
  static getAllInfo(obj) {
    function getBase() {
      return getOlderDetail(obj)
    }
    function getContact() {
      return olderContact(obj)
    }
    return axios.all([getBase(), getContact()]).then(
      axios.spread((base, contact) => {
        return {
          base: base,
          contact: contact
        }
      })
    )
  }
  static addSomeContact(arr) {
    function edit(param) {
      return editContact(param)
    }
    function add(param) {
      return addContact(param)
    }
    let editArr = new Array()
    let addArr = new Array()
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].gid) {
        editArr.push(edit(arr[i]))
      }
      else {
        addArr.push(add(arr[i]))
      }
    }
    return axios.all([...addArr, ...editArr]).then(
      res => {
        return res
      }
    ).catch((err) => {
      return Promise.reject(`获取请求参数失败:${JSON.stringify(err)}`)
    })
  }
  //-------老人养老服务请求    --请求老人详细信息  还有  老人的养老服务登记状态
  static openService(detail, status) {
    function getDetail() {
      return getOlderDetail(detail)
    }
    function getApprove() {
      return getApproveList(status)
    }
    function getSameAccount() {
      return searchSameAccount(detail)
    }
    function getNursedOne() {
      return getSameHouseOldersApi({ index: 0, size: 100000, theoldgid: detail.gid })
    }
    return axios.all([getDetail(), getApprove(), getSameAccount(), getNursedOne()]).then(
      axios.spread((detail, status, same, nursed) => {
        const obj = {
          serviceForm: detailTrans(detail.data),
          openning: status.data.data.length > 0 ? true : false,
          sameAccount: sameAccount(same),
          nursed: nursed.data || []
        }
        return obj
      })
    ).catch((err) => {
      return Promise.reject(`获取数据失败:${JSON.stringify(err)}`)
    })
  }
}

